module.exports = __webpack_public_path__ + "img/quina.d1e8af60.png";